import { render, staticRenderFns } from "./ListOfProperties.vue?vue&type=template&id=777d5726&"
import script from "./ListOfProperties.vue?vue&type=script&lang=js&"
export * from "./ListOfProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports